/* eslint-disable max-len */

// Helper function to calculate polygon centroid
export const calculatePolygonCentroid = (vertices: [number, number][]) => {
  if (!vertices.length) {
    return { lat: 0, lng: 0 };
  }

  let sumLat = 0;
  let sumLng = 0;
  let signedArea = 0;

  for (let i = 0; i < vertices.length; i++) {
    const current = vertices[i];
    const next = vertices[(i + 1) % vertices.length];

    const area = current[0] * next[1] - next[0] * current[1];
    signedArea += area;

    sumLat += (current[0] + next[0]) * area;
    sumLng += (current[1] + next[1]) * area;
  }

  signedArea = signedArea / 2;

  // Handle edge case where area is very small
  if (Math.abs(signedArea) < 1e-10) {
    // If area is too small, just average the points
    return {
      lat: vertices.reduce((sum, point) => sum + point[0], 0) / vertices.length,
      lng: vertices.reduce((sum, point) => sum + point[1], 0) / vertices.length
    };
  }

  const factor = 1 / (6 * signedArea);

  return {
    lat: sumLat * factor,
    lng: sumLng * factor
  };
};
